export enum GIVE_BUTTON_BEHAVIOUR {
  STANDARD = 'STANDARD',
  URL_REDIRECT = 'URL_REDIRECT',
}
